"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const listOpexsUseCase_1 = __importDefault(require("@/useCases/opexs/listOpexsUseCase"));
const listSystemsUseCase_1 = __importDefault(require("@/useCases/systems/listSystemsUseCase"));
const selectors_1 = require("@/store/ducks/opexs/selectors");
const selectors_2 = require("@/store/ducks/systems/selectors");
const formik_1 = require("formik");
const createOpexUseCase_1 = __importDefault(require("@/useCases/opexs/createOpexUseCase"));
const updateOpexUseCase_1 = __importDefault(require("@/useCases/opexs/updateOpexUseCase"));
const HeaderTab_1 = __importDefault(require("@/components/HeaderTab"));
const Toast_1 = __importDefault(require("@/components/Toast"));
const opexs_1 = require("@/store/ducks/opexs");
const OtherCostsContext = (0, react_1.createContext)({
    activeTab: 0,
    setActiveTab: undefined,
    tabs: [],
    showFooter: true,
    setShowFooter: undefined,
    activeData: undefined,
});
const TableRowMolecule = ({ name, values }) => {
    return (react_1.default.createElement(material_1.TableRow, { key: "row.name", sx: { "&:last-child td, &:last-child th": { border: 0 } } },
        react_1.default.createElement(material_1.TableCell, null, name),
        values.map((number, index) => (react_1.default.createElement(material_1.TableCell, { key: index, align: "right" },
            react_1.default.createElement(material_1.TextField, { id: "standard-basic", variant: "outlined", value: number }))))));
};
const FooterButtonsMolecule = () => {
    return (react_1.default.createElement(material_1.Stack, { direction: "row", spacing: 2 },
        react_1.default.createElement(material_1.Button, { variant: "contained", type: "reset" }, "Discard changes"),
        react_1.default.createElement(material_1.Button, { type: "submit", variant: "contained" }, "Save changes")));
};
const OtherCostsHeaderOrganism = () => {
    const { activeTab, setActiveTab, tabs } = (0, react_1.useContext)(OtherCostsContext);
    return (react_1.default.createElement(HeaderTab_1.default, { currentTab: activeTab, onChangeTab: (_, value) => setActiveTab?.(value), options: tabs.map((tab, index) => ({ label: tab, value: index.toString() })), title: "Other costs" }));
};
const OtherCostsContentOrganism = () => {
    const { activeData } = (0, react_1.useContext)(OtherCostsContext);
    const systemsData = (0, react_redux_1.useSelector)(selectors_2.systemsSelector);
    const areSystemsLoading = (0, react_redux_1.useSelector)(selectors_2.areSystemsLoadingSelector);
    const dispatch = (0, react_redux_1.useDispatch)();
    const opexsBySystemId = () => {
        const opexsBySystemId = {};
        activeData?.forEach((opex) => {
            if (opexsBySystemId[opex.systemId]) {
                opexsBySystemId[opex.systemId].push(opex);
            }
            else {
                opexsBySystemId[opex.systemId] = [opex];
            }
        });
        return opexsBySystemId;
    };
    const getSystemNameById = (id, systems) => {
        const system = systems.find((system) => system.id === id);
        if (areSystemsLoading) {
            return id;
        }
        return system?.name;
    };
    const handleOnChange = (e, index, replace) => {
        replace(index, e.target.value);
    };
    return (react_1.default.createElement(material_1.Container, { maxWidth: "lg" },
        react_1.default.createElement(material_1.Grid, { container: true, pt: 3, pb: 3 }, Object.entries(opexsBySystemId()).map((entry) => {
            const [systemId, opex] = entry;
            const systemNameById = getSystemNameById(systemId, systemsData);
            const data = opex[0].data ? JSON.parse(opex[0].data) : [];
            const formattedData = Object.entries(data);
            return (react_1.default.createElement("div", { key: systemId },
                react_1.default.createElement(material_1.Typography, { key: systemId, mt: "24px", mb: "12px", variant: "h3" }, systemNameById),
                react_1.default.createElement(formik_1.Formik, { initialValues: data, onSubmit: async (values) => {
                        const payload = {
                            name: "Impact of Si concentration",
                            data: JSON.stringify(values),
                            systemId: systemId,
                        };
                        await (0, updateOpexUseCase_1.default)(opex[0].id, payload)(dispatch);
                    } }, ({ values }) => {
                    return (react_1.default.createElement(formik_1.Form, null,
                        react_1.default.createElement(material_1.TableContainer, { component: material_1.Paper },
                            react_1.default.createElement(material_1.Table, { sx: { minWidth: 650 }, "aria-label": "simple table" },
                                react_1.default.createElement(material_1.TableBody, null, formattedData.map((entryData, index) => (react_1.default.createElement(formik_1.FieldArray, { key: index + entryData[0], name: entryData[0] }, ({ replace }) => (react_1.default.createElement(material_1.TableRow, { key: "row.name", sx: { "&:last-child td, &:last-child th": { border: 0 } } },
                                    react_1.default.createElement(material_1.TableCell, null, entryData[0]),
                                    values[entryData[0]].map((value, index) => (react_1.default.createElement(material_1.TableCell, { key: `${entryData[0]}.${index}`, align: "right" },
                                        react_1.default.createElement(material_1.TextField, { id: "standard-basic", name: `${entryData[0]}.${index}`, onChange: e => handleOnChange(e, index, replace), variant: "outlined", value: value })))))))))))),
                        react_1.default.createElement(material_1.Grid, { container: true, justifyContent: "flex-end" },
                            react_1.default.createElement(material_1.Grid, { item: true, pb: 3, pt: 3 },
                                react_1.default.createElement(FooterButtonsMolecule, null)))));
                })));
        }))));
};
const OtherCostsFooterOrganism = () => {
    const { showFooter } = (0, react_1.useContext)(OtherCostsContext);
    return (react_1.default.createElement(material_1.Slide, { direction: "up", in: showFooter, mountOnEnter: true, unmountOnExit: true },
        react_1.default.createElement("div", null,
            react_1.default.createElement(material_1.Container, { maxWidth: "lg" },
                react_1.default.createElement(material_1.Grid, { container: true, justifyContent: "flex-end" },
                    react_1.default.createElement(material_1.Grid, { item: true, pb: 3, pt: 3 },
                        react_1.default.createElement(FooterButtonsMolecule, null)))))));
};
const OtherCostsTemplate = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(OtherCostsHeaderOrganism, null),
        react_1.default.createElement(OtherCostsContentOrganism, null)));
};
function OtherCostsPage() {
    const [activeTab, setActiveTab] = (0, react_1.useState)(0);
    const [showFooter, setShowFooter] = (0, react_1.useState)(true);
    const dispatch = (0, react_redux_1.useDispatch)();
    const opexsData = (0, react_redux_1.useSelector)(selectors_1.opexsSelector);
    const systemsData = (0, react_redux_1.useSelector)(selectors_2.systemsSelector);
    const opexToastStatus = (0, react_redux_1.useSelector)(selectors_1.opexToastStatusSelector);
    const getSiteTabs = () => {
        const systemIdArrayFromOpexs = opexsData.map((opex) => opex.systemId);
        const siteNames = systemsData.filter((system) => systemIdArrayFromOpexs.includes(system.id)).map((system) => system.site.name);
        return Array.from(new Set(siteNames));
    };
    const getActiveDataBasedOnTab = () => {
        const systemsContainedInActiveTab = systemsData.filter((system) => system.site.name === getSiteTabs()[activeTab])?.map((system) => system.id);
        const opexDataIncludedInActiveTab = opexsData.filter((opex) => systemsContainedInActiveTab.includes(opex.systemId));
        return opexDataIncludedInActiveTab;
    };
    const createOpex = () => {
        const payload = {
            name: "Impact of Si concentration",
            data: "{\"Nível de Si (ppb) GAP\":[600,750,900,1050,1200,1350,1500,1800,2100,2400], \"Nível de Si (ppb) NAFTA\":[600,750,900,1050,1200,1350,1500,1800,2100,2400]}",
            systemId: "298d4250-985c-4d6f-80fe-83f4458f60f2"
        };
        (0, createOpexUseCase_1.default)(payload)(dispatch);
    };
    const onCloseToast = react_1.default.useCallback((event, reason) => {
        if (reason === "clickaway") {
            dispatch((0, opexs_1.closeOpexToastReducer)());
        }
    }, [opexs_1.closeOpexToastReducer, dispatch]);
    (0, react_1.useEffect)(() => {
        (0, listOpexsUseCase_1.default)()(dispatch);
        (0, listSystemsUseCase_1.default)()(dispatch);
    }, []);
    (0, react_1.useEffect)(() => {
        let close = undefined;
        if (opexToastStatus?.isOpen) {
            close = setInterval(() => {
                dispatch((0, opexs_1.closeOpexToastReducer)());
            }, 3000);
        }
        return () => clearInterval(close);
    }, [opexToastStatus?.isOpen, opexToastStatus, dispatch]);
    const contextValue = {
        activeTab,
        setActiveTab,
        tabs: getSiteTabs(),
        showFooter,
        setShowFooter,
        activeData: getActiveDataBasedOnTab(),
    };
    return (react_1.default.createElement(OtherCostsContext.Provider, { value: contextValue },
        react_1.default.createElement(OtherCostsTemplate, null),
        react_1.default.createElement(Toast_1.default, { isOpen: Boolean(opexToastStatus?.isOpen), severity: "success", onClose: onCloseToast, message: opexToastStatus?.message, 
            // anchorOrigin={anchorOrigin}
            closeText: "X" })));
}
exports.default = OtherCostsPage;
//TODO: create toats
